import React from 'react'
import styled from 'styled-components'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface DropdownItemProps {
  icon?: IconProp
  disabled?: boolean
  children: React.ReactNode
  [k: string]: any
}

export const DropdownItem = (props: DropdownItemProps) => {
  const { icon, children, ...rest } = props
  return (
    <Item {...rest}>
      {icon && <Icon icon={icon} />}
      {children}
    </Item>
  )
}

const Icon = styled(FontAwesomeIcon)`
  margin-right: 5px;
  width: 30px;
`

const Item = styled.div<{ disabled?: boolean }>`
  display: flex;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  color: #354052;
  background: #fff;
  height: 37px;
  cursor: ${({ disabled, onClick }) =>
    disabled ? ' not-allowed;' : onClick ? 'pointer' : 'default'};
  min-width: 150px;
  font-family: 'Source Sans Pro';
  border: 1px solid #dfe3e9;
  border-bottom: none;

  &:first-child {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  &:last-child {
    border: 1px solid #dfe3e9;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:hover {
    background: #f1f4f8;
    color: ${props => props.theme.colors.azure};
  }
`
